import { RolesList, OperationsList } from "@gtpl/shared-models/gtpl";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
@Entity('logs')
export class Logs {

  @PrimaryGeneratedColumn("increment", { name: 'log_id' })
  logId: number;

  @Column({
    type: 'varchar',
    nullable: false,
    name: 'table_name'
  })
  tableName: string;

  @Column({
    type: 'varchar',
    length: 25,
    nullable: true,
    name: "operation"
  })
  operationName: string;

  @Column("int", {
    nullable: false,
    name: "row_id"
  })
  rowId: number | null;

  @Column({
    type: 'varchar',
    length: 100,
    nullable: true,
    name: "display_value"
  })
  displayValue: string;

  @Column({
    type: 'varchar',
    nullable: true,
    name: "previous_value"
  })
  previousValue: string;

  @Column({
    type: 'varchar',
    nullable: true,
    name: "present_value"
  })
  presentValue: string;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "status"
  })
  status: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
}
